import KeyIcon from '@mui/icons-material/Key';
import { RoleList } from './Role.List';
import { RoleCreate } from './Role.Create';
import { RoleEdit } from './Role.Edit';

export default {
    list: RoleList,
    create: RoleCreate,
    edit: RoleEdit,
    icon: KeyIcon,
};
